import React, { useEffect } from "react";
import styled from "styled-components"
import {isMobile} from 'react-device-detect';

import Layout from "../components/layout"
import Container from "../components/container"
import PageHeader from "../components/header-page"

import busStopSign from "../images/busstopsign.jpg"

import ReactGA from "react-ga4";
ReactGA.initialize("G-THHYTX4Y9V");

const Content = styled.div`
  display: flex;
  flex-flow: ${isMobile ? "column":"unset"};
  padding-bottom: 75px;
  
  h2:nth-child(1) {
    margin-top: 0px;
  }

  a {
    color: white;
  }

  li {
    margin-bottom: 15px;
  }
`
const GreenMachine = styled.div`
  padding: 25px;
  flex-basis: 50%;

  img {
    max-width: 100%;
  }

  ul {
    list-style-type: none;
    margin: 0px;
    padding: 0px;
    position: relative;
    top: -5px;

    li {
      padding: 12px;
      background-color: white;
      color: black;
      margin-bottom: 1px;      

      a {
        color: black;
      }
    }
  }
`

function StudentsPage(props) {
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: "/students", title: "Students"});
  }, []);

  return (
    <Layout page="students" title="Students">
      <Container>
        <PageHeader>Student Information</PageHeader>
      </Container>
      <Container>
        <Content>
          <div>
            <h2>Marshall Artists Series Contact info:</h2>
            <ul>
                <li>304-696-3326</li>
                <li><a href="http://www.marshallartistsseries.org">www.marshallartistsseries.org</a></li>
                <li>artistsseries@marshall.edu</li>
                <li>Box office is located on the campus of Marshall University on 5th Ave., in the Joan C. Edwards Performing Arts Center – across from the student center.</li>
                <li>Box office hours – Mon – Fri, 9 a.m. – 4 p.m.</li>
            </ul>

            <h2>Marshall Student Tickets:</h2>
            <ul>
                <li>Student tickets are typically released 3 weeks in advance of show.</li>
                <li>Student must present MU ID at the box office when getting tickets.</li>
                <li>Students may bring one other MU ID to the box office, to pick up a ticket for a friend.</li>
                <li>Students must present MU ID at the theatre for entry to each event.</li>
            </ul>

            <h2>Important Info:</h2>
            <ul>
                <li>All shows start at 7:30 pm unless noted.</li>
                {/* <li>All film festival ticketing is done at the Keith-Albee Theatre prior to each film.  No advance tickets are distributed.</li> */}
            </ul>
          </div>
          <GreenMachine>
            <div>
              <img src={busStopSign} alt="Green Machine Bus Stop" />
            </div>
            <ul>
              <li>Bus service is available from campus to locations including the Keith-Albee Theatre.</li>
              <li>Visit <a href="http://www.marshall.edu/student-affairs/greenmachine" target="_blank">http://www.marshall.edu/student-affairs/greenmachine</a> for routes and schedules</li>
            </ul>            
          </GreenMachine>
        </Content>
      </Container>
    </Layout>
  );
}

export default StudentsPage;